<template>
  <section class="hero has-bg-img-1">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column has-text-centered-mobile is-narrow">
            <img src="../assets/nthu-logo.png">
          </div>
          <div class="column">
            <h1 class="title has-text-white is-size-3-mobile has-text-centered-mobile">大芝加哥<br class="is-hidden-tablet">國立清華大學<br class="is-hidden-tablet">校友會</h1>
            <h2 class="subtitle has-text-white is-size-5-mobile has-text-centered-mobile">National Tsing Hua University <br/>Alumni Association <br class="is-hidden-tablet">of Greater Chicago</h2>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'banner',
};
</script>

<style lang="scss" scoped>
.has-bg-img-1 {
  background:
    linear-gradient(0deg, rgba(127, 16, 132, 0.4), rgba(127, 16, 132, 0.4)),
    url("../assets/banner-bg-1.jpg");
  background-size: cover;
  background-position: center top;

  @media screen and (max-width: 769px) {
    background-position: center, 81%;
  }
}

.hero {
  img {
    max-width: 7.3em;
  }
}

.title {
  letter-spacing: 0.08em;
}

.title, .subtitle {
  line-height: 1.5em;
}
</style>
